<template>
  <div id="draw-sign-layer">
    <el-dialog :append-to-body="true" title="制作手绘印章" :visible.sync="dialogVisible" width="506px" :show-close="true" :center="true">
      <img class="draw-sign" :src="qrCode" alt="">
      <p class="draw-text">请打开手机扫一扫二维码，绘制印章五分钟内有效</p>
      <div class="dialog-btns">
        <el-button type="primary" @click="getDrawCodeHandle" class="btn-ok">重新获取</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDrawCodeApi } from '@/api/space/signatures'
export default {
  data() {
    return {
      dialogVisible: false,
      qrCode: ''
    }
  },
  methods: {
    getDrawCodeHandle() {
      getDrawCodeApi().then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.qrCode = res.data.qrCode
        }
      })
    }
  }
}
</script>
<style scoped>
  .draw-sign{
    width: 191px;
    margin: 0px auto 0;
    display: block;
  }

  .draw-text{
    width: 256px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    margin: 40px auto 20px;
  }

  .dialog-btns{
    width: 405px;
    margin: 40px auto 0;
    display: flex;
    justify-content: center;
    overflow: hidden;
  }

  .dialog-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
  }
</style>